// extracted by mini-css-extract-plugin
export default {"icon":"IsAiTask_icon__b6yca"};